<script lang="ts" setup>
import LogoComponent from '#assets/crf-logo-horizontal.svg';
import { config } from '#core/config/env';
import routes from '#webui/router/routes';
import { C4Menu, IconVueFeather, type MenuDataType } from '@c4-links/vue3-links-components';
import { computed } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import { useLanguage } from '../composables/useLanguage';
import { sideBarMenuData } from './sideBarMenuData.utils';

const props = defineProps({
  isOpen: { type: Boolean, default: false }
});

const emit = defineEmits<{
  toggle: [opened: boolean];
}>();

const { t } = useLanguage();

const sideBarClass = computed(() => ({
  'px-8': props.isOpen,
  '!w-sidebar-close px-4': !props.isOpen
}));

const handleToggle = (opened: boolean) => {
  emit('toggle', !opened);
};

const handleClick = (route: MenuDataType) => {
  if (route.id === 'contact') {
    window.open(config.supportUrl, '_blank');
  }
};

const route = useRoute();
const parentPath = computed(() => route.matched);
</script>

<template>
  <nav
    :class="sideBarClass"
    class="bg-white h-screen w-sidebar-width border-r border-default-very-light py-6"
    role="navigation"
  >
    <div class="flex flex-col h-full">
      <div class="flex flex-col grow">
        <div class="flex flex-col mb-6">
          <div class="flex justify-between space-x-4 gap-2">
            <RouterLink
              v-if="isOpen"
              :to="{ name: routes.innovation.name }"
              variant="secondary"
              class="w-full border rounded border-default-very-light flex justify-center"
            >
              <LogoComponent class="h-10" />
            </RouterLink>
            <IconVueFeather
              :size="18"
              class="cursor-pointer"
              :type="isOpen ? 'chevrons-left' : 'chevrons-right'"
              @click="() => handleToggle(isOpen)"
            />
          </div>
          <div v-if="isOpen" class="flex items-center text-default-tertiary h-12 mb-2">
            {{ t('inno_navbar.title') }}
          </div>
        </div>
        <C4Menu
          :is-collapsed="!isOpen"
          :is-menu-section="true"
          :menu-data="sideBarMenuData({ t, matches: parentPath })"
          @selected-menu="handleClick"
        />
      </div>
    </div>
  </nav>
</template>
